import { loaderAction, subscriptionCalendarAction } from "../rootReducer";
import { api } from "../../helpers/api";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getSubscriptionsSagaAction, getUserInfoSagaAction } from "../sagaActions";
import { SUBSCRIPTION_CALENDAR_INITIAL } from "../initialStateConstant";

export const addRecordThunk = (args) => async (dispatch, getState) => {
    const { user, currentUser, currentEstablishment } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', currentEstablishment);
        formData.append('subscription_id', args.subscription_id);
        formData.append('date', args.date);
        formData.append('approved', args.approved || '');
        formData.append('workout_type', args.workout_type || '');
        formData.append('user', currentUser.id || '');

        const response = await api({ data: formData, link: 'add_record' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем календарь
            dispatch(subscriptionCalendarAction(SUBSCRIPTION_CALENDAR_INITIAL));

            // Если списывали тренировку из абонемента на странице пользователя
            if (currentUser.id) {
                // Обновляем данные пользователя (с абонементами)
                dispatch(getUserInfoSagaAction({ id: currentUser.id }));
            }
            // Если списывали тренировку из абонемента на странице с абонементами
            else {
                // Обновляем список с абонементами
                dispatch(getSubscriptionsSagaAction());
            }

            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
        else if (response.warning) {
            if (window.confirm(response.message)) {
                dispatch(addRecordThunk({
                    subscription_id: args.subscription_id,
                    date: args.date,
                    approved: 'approved',
                    workout_type: args.workout_type || ''
                }));
            }
        }
    }
    catch(error) {
        console.log(error);
        dispatch(loaderAction(false));
    }
    finally {
        dispatch(loaderAction(false));
    }
};